export default "__VITE_ASSET__Ca8wn10r__"